// extracted by mini-css-extract-plugin
module.exports = {"loadingMessage":"styles-module_loadingMessage_1zU3C"};